"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const app_1 = require("app");
const Sidebar = ({ className, close, closeBreakpoint, opened, children, }) => {
    const sidebarRef = (0, react_1.useRef)(null);
    const listenerFn = (0, react_1.useCallback)(() => {
        /*
         * "touchstart" event should be used for correct work of CSS :active state
         * https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari
         */
    }, []);
    const onWindowResize = (0, react_1.useCallback)(() => {
        if (close &&
            closeBreakpoint !== undefined &&
            (0, app_1.detectBreakpoint)(closeBreakpoint) &&
            opened === true) {
            close();
        }
    }, [close, closeBreakpoint, opened]);
    const throttledResizeHandler = (0, react_1.useMemo)(() => (0, app_1.throttle)(onWindowResize, 200), [onWindowResize]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('resize', throttledResizeHandler);
        const sidebarNode = sidebarRef.current;
        sidebarNode === null || sidebarNode === void 0 ? void 0 : sidebarNode.addEventListener('touchstart', listenerFn, true);
        return () => {
            window.removeEventListener('resize', throttledResizeHandler);
            sidebarNode === null || sidebarNode === void 0 ? void 0 : sidebarNode.removeEventListener('touchstart', listenerFn);
        };
    }, [listenerFn, throttledResizeHandler]);
    return ((0, jsx_runtime_1.jsx)("div", { ref: sidebarRef, "data-testid": `sidebar-${opened ? 'opened' : 'closed'}`, className: `bg-surface-primary z-navigation fixed top-0 h-full w-full min-w-[320px] left-0 ${opened ? '' : 'hidden'}`, children: opened ? ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { timeout: 300, children: children }, "sidebar")) : null }));
};
exports.default = Sidebar;
